<template>
  <div class="index-page">
    <div class="bg">
      <header>
        <div class="logo-wrap">
          <img src="@/assets/logo.png" class="logo" alt="飞速侠">
          <h1>飞速侠</h1>
          <a href="https://shimo.im/docs/PqqtjWDHggRtvyvC/" target="_blank">帮助中心</a>
        </div>
        <div class="login-wrap">
          <a href="javascript:void(0);" v-if="!isLogin" @click="showLoginDialog">登录/注册</a>
          <a href="javascript:void(0);" v-if="isLogin" @click="goToApp">进入web版</a>
        </div>
      </header>

      <div class="intro">
        <h1>飞速侠 - 专业个人云加速服务</h1>
        <h3>我们通过阿里云、腾讯云、百度云、以及各种边缘CDN节点，帮你预加速互联网的公开访问内容</h3>
        <p>*目前服务仅提供给中国大陆地区</p>
      </div>

      <div class="button-wrap">
        <a :href="updateInfo.windows" class="button-item" :class="{'disable': !updateInfo.windows}"  target="_blank">
          <i class="iconfont icon-Windows"></i>Windows 下载
        </a>
        <a :href="updateInfo.mac" class="button-item" :class="{'disable': !updateInfo.mac}"  target="_blank">
          <i class="iconfont icon-mac"></i>Mac 下载
        </a>
        <a v-if="updateInfo.android" :href="updateInfo.android" class="button-item" target="_blank">
          <i class="iconfont icon-android"></i>Android 下载
        </a>
        <a v-if="!updateInfo.android" href="javascript:void(0)" class="button-item disable" @click="showTip">
          <i class="iconfont icon-android"></i>Android 下载
        </a>
      </div>
      <p class="tip">最新版本：{{updateInfo.version}} 更新时间：{{updateInfo.updatetime}}</p>
      <p class="tip" v-if="updateInfo.intro">{{updateInfo.intro}}</p>
    </div>

    <div class="intro-wrap">
      <img src="@/assets/display.png" class="display" alt="">
      <img src="@/assets/intro_1.png" class="intro_1" alt="">
      <img src="@/assets/intro_2.png" class="intro_2" alt="">
    </div>
    <footer> 
      <span v-if="!showKrzb">Copyright © 飞速侠 Team 2020 Foundation.  <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank">沪ICP备2020034055号-2</a></span>
      <span v-if="showKrzb">Copyright © 飞速侠 Team 2020 Foundation.  <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank">沪ICP备2023017749号-1</a></span>
    </footer>
  </div>
</template>

<script>
export default {
  data () {
    return {
      showKrzb: location.origin.includes('krzb'),
    }
  },
  methods: {
    showTip () {
      this.$message.success('正在开发中，敬请期待。')
    },
    goToApp () {
      this.$router.push('/app/task')
    }
  }
}
</script>

<style lang="scss" scoped>
$theme-width: 940px;
$theme-color: #0054FE;
.index-page {
  min-width: $theme-width;
}
.bg {
  color: #fff;
  height: 600px;
  background-image: url('../assets/bg.png');
  background-size: cover;
}

header {
  display: flex;
  width: $theme-width;
  margin: 0 auto;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  .logo-wrap {
    display: flex;
    align-items: center;
  }
  h1 {
    font-size: 20px;
    margin-right: 20px;
  }
  .logo {
    height: 40px;
    margin-right: 10px;
  }
  a {
    color: #fff;
    text-decoration: none;
    padding-bottom: 2px;
  }
}
 .intro {
   margin-top: 80px;
    text-align: center;
    h1 {
      font-weight: normal;
      font-size: 30px;
    }
    h3 {
      margin-top: 20px;
    }
    p {
      font-size: 14px;
      margin-top: 10px;
    }
  }

.button-wrap {
  margin-top: 25px;
  display: flex;
  justify-content: center;
  .button-item {
    padding: 5px 15px;
    border: 1px solid #fff;
    border-radius: 2px;
    margin-right: 10px;
    color: #fff;
    transition: all ease 0.2s;
    text-decoration: none;
    display: flex;
    align-items: center;
    i {
      font-size: 18px;
      margin-right: 4px;
    }
    &:last-child {
      margin-right: 0;
    }
    &:hover {
      color: $theme-color;
      background-color: #fff;
    }
    &.disable {
      background-color: #eee;
      color: #666;
    }
  }
}

.tip {
  margin-top: 10px;
  text-align: center;
  font-size: 13px;
}

.intro-wrap {
  width: $theme-width;
  margin: -200px auto 20px;
  img {
    width: 100%;
  }
  .intro_2, .intro_1 {
    margin-top: 60px;
  }
}

footer {
  margin-top: 80px;
  height: 90px;
  display: flex;
  align-items: center;
  color: #fff;
  justify-content: center;
  background-image: url('../assets/footer.png');
  background-size: cover;
  text-align: center;
  font-size: 12px;
}
</style>
